<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/series/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeileixing')">
						<yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.conditions.typeId">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('shebeixiliemingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
		<!-- 	<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('shebeixinghao', scope.row,'80%')">
							{{$t('xinghao')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/series/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeileixing')" required>
						<yi_dictionary_select :type="'EQUIPMENT_TYPES'" :ids.sync="yt.editObj.typeId">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('shebeixiliemingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/equipment/series/create')" type="primary">{{$t('baocun')}}
					</el-button>

				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeileixing')" required>
						{{$t(store.state.dictJson['EQUIPMENT_TYPES'][yt.editObj.typeId])}}
					</el-form-item>
					<el-form-item :label="$t('shebeixiliemingcheng')" required>
						<el-input v-model="yt.editObj.name"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/equipment/series/update')" type="primary">
						{{$t('baocun')}}
					</el-button>

				</span>
			</template>
			<!-- 设备型号 -->
			<template v-if="yt.editObj.action == 'shebeixinghao'">
				<div class="dialog-scroller">
					<series_model :series="yt.editObj"></series_model>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import series_model from '@@/pages/admin/equipment/series/series_model'
	export default {
		name: 'admin_equipment_series_list',

		components: {
			series_model
		},
		data() {
			return {
				columns: [{
					label: 'shebeileixing',
					prop: 'typeId',
					type: 'dictionary',
					key: 'EQUIPMENT_TYPES'
				}, {
					label: 'shebeixiliemingcheng',
					prop: 'name'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 200,
					fixed: 'right'
				}]
			};
		},
		computed: {
			changeEquipmenSeries() {
				if (this.yt.editObj.typeId) {
					let series = store.state.dictJson['EQUIPMENT_TYPES'][yt.editObj.typeId];
					return $t(series);
				}
				return ""
			}
		},
		created() {
			setTimeout(() => {
				this.yt.SELECT_URL = "/web/equipment/series/page"
				this.yt.SELECT_RESULT_KEY = "data"
				this.yt.SELECT_ID = "id"
				this.yt.SELECT_TITLE = "name"
				this.yt.get(1)
			}, 300)


		},
		methods: {
			getEquipentType() {
				return "$t('{{}})"
			}
		}
	};
</script>
